// extracted by mini-css-extract-plugin
export var locationsContainer = "_zn-2";
export var locationsTextContainer = "_zn-1";
export var mapContainer = "_zn-0";